import React from 'react'

interface WorkFlowIconProps {
    size?: number
    color?: string
}

export default function WorkFlowIcon({ size=20, color="#D95970" }: WorkFlowIconProps ) {
    return (
        <svg  width={size} height={size} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Group 1000001473">
            <circle id="Ellipse 1012" cx="5" cy="5" r="4.1" stroke={color} stroke-width="0.8"/>
            <circle id="Ellipse 1013" cx="5" cy="5" r="1.5" fill={color}/>
            </g>
        </svg>
        
    )
}
